import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import styles from './MobileUploadButton.module.scss';
import { useTranslation } from 'react-i18next';
import { LoadingSpinner } from '../Icon/icons';
import Icon from '../Icon/Icon';
import { useUserContext } from '../../context/UserContext';

function MobileUploadButton({ setIsShowUploadVideoModal }) {
  const { t } = useTranslation();
  const { appConfig } = useUserContext();

  return (
    <div className={styles.sectionWrapper}>
      <span className={styles.titleSecond}>{t('home_page.upload_video')}</span>
      {appConfig ? (
        <div className={styles.recordOptionsContainer}>
          <div className={styles.recordOptions} onClick={() => setIsShowUploadVideoModal(true)}>
            <div className={styles.recordIconContainer}>
              <Icon src="record" className={styles.recordIcon} />
            </div>
            <span>{t('dashboard.new_video.upload_video.button')}</span>
          </div>
        </div>
      ) : (
        <div className={styles.spinnerContainer}>
          <LoadingSpinner theme="light" />
        </div>
      )}
    </div>
  );
}

export default MobileUploadButton;
